import React from 'react';
import List from './List';

const IndexParList = ({ modifiedIndexParList, staticList, dynamicList }) => {
  return modifiedIndexParList == undefined || modifiedIndexParList == {} ? (
    <List list={staticList} />
  ) : (
    <List list={dynamicList} />
  );
};

export default IndexParList;
